document.addEventListener('DOMContentLoaded', () => {
  // 1. DOM references
  const $overlay = $('.bkt-mastery__popup-overlay');
  const $iframe  = $overlay.find('iframe');
  const $thumbs  = $('.bkt-mastery__youtube-thumbnail');
  const $titles  = $('.bkt-mastery__youtube-title');
  const $closes  = $('.bkt-mastery__popup-close');

  // 2. Helpers (open/close popup)
  const openVideoPopup = (youtubeID) => {
    const url = `https://www.youtube.com/embed/${youtubeID}?autoplay=1`;
    $overlay.fadeIn(200).addClass('active').removeClass('inactive');
    $iframe.attr('src', url);
  };

  const closeVideoPopup = () => {
    $overlay.fadeOut(200).removeClass('active').addClass('inactive');
    $iframe.attr('src', ''); // Stop Video
  };

  // 3. Click On Thumbnail
  $thumbs.on('click', function () {
    const src = $(this).attr('src');
    const match = src.match(/\/vi\/([^/]+)\//);
    if (match) {
      openVideoPopup(match[1]); // only open if a valid ID was found
    } else {
      console.warn('No YouTube video found for this thumbnail.');
    }
  });

  // 4. Click On Title
  $titles.on('click', function () {
    const $card = $(this).closest('.education_youtube_card');
    const thumbSrc = $card.find('.bkt-mastery__youtube-thumbnail').attr('src');

    const match = thumbSrc ? thumbSrc.match(/\/vi\/([^/]+)\//) : null;

    if (match) {
      // Valid YouTube video ID → open popup
      const id = match[1];
      openVideoPopup(id);
    } else {
      console.warn('No YouTube video found for this title.');
    }
  });

  // 5. Close Popup
  $closes.add($overlay).on('click', (e) => {
    if (
      $(e.target).closest('.bkt-mastery__popup-close').length ||
      $(e.target).is('.bkt-mastery__popup-overlay')
    ) {
      closeVideoPopup();
    }
  });
});